import { createContext, useContext, type ReactNode } from 'react';
import { useBookingFlow, type BookingFlow, type BookingFlowResumeSeed } from './useBookingFlow';
import type { BookingFlowConfig } from './types';

const BookingFlowContext = createContext<BookingFlow<unknown> | null>(null);

export function BookingFlowProvider<TState>({
  config,
  resume,
  children,
}: {
  config: BookingFlowConfig<TState>;
  /** Set by `<BookingFlowResumer>` to start the flow mid-way after a refresh. */
  resume?: BookingFlowResumeSeed<TState>;
  children: ReactNode;
}) {
  const flow = useBookingFlow(config, resume);
  return (
    <BookingFlowContext.Provider value={flow as BookingFlow<unknown>}>
      {children}
    </BookingFlowContext.Provider>
  );
}

export function useBookingFlowContext<TState = unknown>(): BookingFlow<TState> {
  const ctx = useContext(BookingFlowContext);
  if (!ctx) {
    throw new Error('useBookingFlowContext must be used within a BookingFlowProvider');
  }
  return ctx as BookingFlow<TState>;
}
